import { css } from 'styled-components';

const style = () => css`
    width: 48%;
`;

export default style();
